var chunkMapping = {
	"44": [
		3044
	],
	"107": [
		7107
	],
	"206": [
		9206
	],
	"227": [
		5227
	],
	"320": [
		504,
		6015
	],
	"422": [
		1422
	],
	"490": [
		9490
	],
	"621": [
		3621
	],
	"638": [
		7638
	],
	"647": [
		3647
	],
	"690": [
		1706,
		2289,
		2641,
		5302,
		6841,
		7053,
		8527,
		9007
	],
	"708": [
		3919,
		4128
	],
	"832": [
		800
	],
	"838": [
		5838
	],
	"839": [
		1839
	],
	"858": [
		3685,
		8230
	],
	"985": [
		77,
		1376,
		1947,
		2509,
		2740,
		3222,
		3236,
		4894,
		5692,
		6415,
		7095,
		7604,
		7853,
		8151,
		8175,
		8848,
		9051,
		9066
	],
	"988": [
		2988
	]
};
var idToExternalAndNameMapping = {
	"77": [
		"default",
		"./i18next",
		1812
	],
	"504": [
		"default",
		"./react-dom/client",
		1812
	],
	"800": [
		"default",
		"./UnifiedMenu",
		3156
	],
	"1376": [
		"default",
		"./react-redux",
		1812
	],
	"1422": [
		"default",
		"./Avatar",
		3156
	],
	"1706": [
		"default",
		"./PageLayout",
		3156
	],
	"1839": [
		"default",
		"./Card",
		3156
	],
	"1947": [
		"default",
		"./ThemeProvider",
		3156
	],
	"2289": [
		"default",
		"./Button",
		3156
	],
	"2509": [
		"default",
		"./react",
		1812
	],
	"2641": [
		"default",
		"./Tabs",
		3156
	],
	"2740": [
		"default",
		"./auth",
		3344
	],
	"2988": [
		"default",
		"./DesktopShell",
		9472
	],
	"3044": [
		"default",
		"./SettingsPanel",
		3156
	],
	"3222": [
		"default",
		"./axios",
		1812
	],
	"3236": [
		"default",
		"./utils",
		3156
	],
	"3621": [
		"default",
		"./App",
		7710
	],
	"3647": [
		"default",
		"./Spotlight",
		3156
	],
	"3685": [
		"default",
		"./@hookform/resolvers/zod",
		1812
	],
	"3919": [
		"default",
		"./DropdownMenu",
		3156
	],
	"4128": [
		"default",
		"./@tanstack/react-table",
		1812
	],
	"4894": [
		"default",
		"./react-router-dom",
		1812
	],
	"5227": [
		"default",
		"./App",
		3482
	],
	"5302": [
		"default",
		"./Badge",
		3156
	],
	"5692": [
		"default",
		"./EventBus",
		3344
	],
	"5838": [
		"default",
		"./KitchenSink",
		3156
	],
	"6015": [
		"default",
		"./styles",
		3156
	],
	"6415": [
		"default",
		"./language",
		3156
	],
	"6841": [
		"default",
		"./Switch",
		3156
	],
	"7053": [
		"default",
		"./Dialog",
		3156
	],
	"7095": [
		"default",
		".",
		3344
	],
	"7107": [
		"default",
		"./App",
		9472
	],
	"7604": [
		"default",
		"./Popover",
		3156
	],
	"7638": [
		"default",
		"./lucide-react",
		1812
	],
	"7853": [
		"default",
		"./a11y",
		3156
	],
	"8151": [
		"default",
		"./react-i18next",
		1812
	],
	"8175": [
		"default",
		"./ShadowBanner",
		3156
	],
	"8230": [
		"default",
		"./react-hook-form",
		1812
	],
	"8527": [
		"default",
		"./react-easy-crop",
		1812
	],
	"8848": [
		"default",
		"./@reduxjs/toolkit",
		1812
	],
	"9007": [
		"default",
		"./useToast",
		3156
	],
	"9051": [
		"default",
		"./Navbar",
		3156
	],
	"9066": [
		"default",
		".",
		3156
	],
	"9206": [
		"default",
		"./motion",
		1812
	],
	"9490": [
		"default",
		"./App",
		1734
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}